import { getGridSingleSelectOperators } from '@mui/x-data-grid-pro';

export const getSingleSelectOperators = () => {
	return getGridSingleSelectOperators().filter(operator => operator.value !== 'isAnyOf');
};
